<button *ngIf="enableExport"
        data-test="export-button"
        class="btn btn-border-radius btn-secondary"
        [ngClass]="getCls()"
        [disabled]="monDisabled"
        (click)="exportFiles()"
        mon-event-trigger="actionTrigger"
        mon-event-params="{action: 'btn-export-dialog'}"
        [ngbTooltip]="'Export' | translate"
        [attr.aria-label]="'Export' | translate">
  <span class="fas fa-download" aria-hidden="true"></span>
  <span class="sr-only">{{ 'Export' | translate }}</span>
</button>
